var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98064 0H6.95332C3.64814 0 0.96875 2.68017 0.96875 5.98634V6.01366C0.96875 9.31983 3.64814 12 6.95332 12H6.98064C10.2858 12 12.9652 9.31983 12.9652 6.01366V5.98634C12.9652 2.68017 10.2858 0 6.98064 0Z",
    fill: "url(#paint0_linear_7129_214680)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8238 2.44141H5.11176C4.08624 2.44141 3.25195 3.27594 3.25195 4.30176V7.69874C3.25195 8.72456 4.08624 9.55909 5.11176 9.55909H8.8238C9.84932 9.55909 10.6836 8.72456 10.6836 7.69874V4.30176C10.6836 3.27594 9.84932 2.44141 8.8238 2.44141ZM3.90803 4.30176C3.90803 3.63792 4.44811 3.09768 5.11176 3.09768H8.8238C9.48744 3.09768 10.0275 3.63792 10.0275 4.30176V7.69874C10.0275 8.36258 9.48744 8.90282 8.8238 8.90282H5.11176C4.44811 8.90282 3.90803 8.36258 3.90803 7.69874V4.30176Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96822 7.73017C7.92186 7.73017 8.69815 6.95408 8.69815 5.99973C8.69815 5.04538 7.92228 4.26929 6.96822 4.26929C6.01415 4.26929 5.23828 5.04538 5.23828 5.99973C5.23828 6.95408 6.01415 7.73017 6.96822 7.73017ZM6.96822 4.92598C7.56041 4.92598 8.04207 5.40778 8.04207 6.00015C8.04207 6.59252 7.56041 7.07432 6.96822 7.07432C6.37602 7.07432 5.89436 6.59252 5.89436 6.00015C5.89436 5.40778 6.37602 4.92598 6.96822 4.92598Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85868 4.54894C9.11548 4.54894 9.32479 4.34 9.32479 4.0827C9.32479 3.8254 9.1159 3.61646 8.85868 3.61646C8.60146 3.61646 8.39258 3.8254 8.39258 4.0827C8.39258 4.34 8.60146 4.54894 8.85868 4.54894Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7129_214680",
    x1: 2.72138,
    y1: 10.2469,
    x2: 11.2151,
    y2: 1.75607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.beaff2dd11898649f25a20a5ffcd1fa1.svg";
export { ForwardRef as ReactComponent };